// extracted by mini-css-extract-plugin
export default {"wrapper":"ServiceItem_wrapper__dTSrc","logo":"ServiceItem_logo__302F2","title":"ServiceItem_title__VcjqM","content":"ServiceItem_content__yebfU"};